exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".progress__seek__2ReJw{position:relative;height:3px;padding:0}.progress__focused__h_5sr{outline:none}.progress__container__3F_ui{position:relative;width:100%;height:100%;background:hsla(0,0%,100%,.3);cursor:pointer}.progress__buffer-bar__34FJT{position:absolute;top:0;left:0;height:100%;background-color:hsla(0,0%,100%,.4)}.progress__progress-bar__3akFK{transition:background .2s;background-color:-wix-colors-buttonsAndLinksColor-70}.progress__container__3F_ui:hover .progress__progress-bar__3akFK{background-color:-wix-colors-buttonsAndLinksColor}.progress__progress-bar__3akFK:after{content:\"\";position:absolute;top:-5px;right:-5px;width:12px;height:12px;background-color:#fff;border-radius:50%}.progress__progress-input__3iwjK{height:12px;bottom:-5px;top:-5px}", ""]);

// exports
exports.locals = {
	"seek": "progress__seek__2ReJw",
	"focused": "progress__focused__h_5sr",
	"container": "progress__container__3F_ui",
	"buffer-bar": "progress__buffer-bar__34FJT",
	"bufferBar": "progress__buffer-bar__34FJT",
	"progress-bar": "progress__progress-bar__3akFK",
	"progressBar": "progress__progress-bar__3akFK",
	"progress-input": "progress__progress-input__3iwjK",
	"progressInput": "progress__progress-input__3iwjK"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/player-widget/components/player/controls/progress/progress.styl
// module id = 1306
// module chunks = 0 1 2 3